/**
 * Busca summary + config do Dossiê com cache em memória.
 * Motivo: a NavBar aparece em TODAS as telas. Sem cache,
 * cada troca de rota dispararia 2 requisições.
 */
import api from "./api";
import { parseHiddenComponents } from "../lib/dossierStatus";

const TTL_MS = 5 * 60 * 1000; // 5 minutos

let cache = { data: null, at: 0, promise: null };

// Chame após salvar qualquer módulo do Dossiê
export function invalidateDossierCache() {
    cache = { data: null, at: 0, promise: null };
}

export function fetchDossierAlertsData({ force = false } = {}) {
    const fresh = cache.data && Date.now() - cache.at < TTL_MS;
    if (!force && fresh) return Promise.resolve(cache.data);
    if (cache.promise) return cache.promise; // evita requisições duplicadas

    cache.promise = Promise.allSettled([
        api.get("/rest-home/dossier/summary"),
        api.get("/rest-home/settings/config-dossier"),
    ])
        .then(([summaryRes, configRes]) => {
            const summaryOk =
                summaryRes.status === "fulfilled" && !summaryRes.value.data?.error;

            // Sem summary não há o que alertar — não guarda em cache
            if (!summaryOk) return { summary: {}, hidden: [] };

            const configOk =
                configRes.status === "fulfilled" && !configRes.value.data?.error;

            cache.data = {
                summary: summaryRes.value.data?.data || {},
                hidden: configOk
                    ? parseHiddenComponents(configRes.value.data.informations)
                    : [],
            };
            cache.at = Date.now();
            return cache.data;
        })
        .finally(() => {
            cache.promise = null;
        });

    return cache.promise;
}